import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { Injector } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BaseServiceService } from './services/base-service/base-service.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ChartsModule } from 'ng2-charts';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { HttpErrorInterceptor } from './services/common/app-error-handler.service';
import { AppCustomPreloader } from './app-routing-loader';
import { ModalModule } from 'ngx-bootstrap/modal';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { SideBarComponent } from './components/side-bar/side-bar.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { ConfirmationApprovalDialogComponent } from './components/confirmation-approval-dialog/confirmation-approval-dialog.component';
import { ConfirmationWarningDialogComponent } from './components/confirmation-warning-dialog/confirmation-warning-dialog.component';
import { SuperSharedModule } from './modules/super-shared/super-shared.module';
import { DataTableModule } from 'angular-6-datatable';

import { NgxPaginationModule } from 'ngx-pagination';
import { HoLoanReleaseDetailsComponent } from './views/ho-loan-release-details/ho-loan-release-details.component';
import { HoLoanDisbursementComponent } from './components/ho-loan-disbursement/ho-loan-disbursement.component';
import { HoLoanDisbursementAllComponent } from './components/ho-loan-disbursement-all/ho-loan-disbursement-all.component';
import { PublicDashboardStateComponent } from './components/public-dashboard-state/public-dashboard-state.component';
import { ShiftApplicationComponent } from './components/shift-application/shift-application.component';
import { ShiftApplicationViewComponent } from './views/shift-application-view/shift-application-view.component';
import { ZonalVerificationComponent } from './components/zonal-verification/zonal-verification.component';
import { ZonalVerificationViewComponent } from './views/zonal-verification-view/zonal-verification-view.component';
import { MergeBranchComponent } from './components/merge-branch/merge-branch.component';
import { MergeBranchViewComponent } from './views/merge-branch-view/merge-branch-view.component';
import { SubsidyReportComponent } from './components/subsidy-report/subsidy-report.component';
import { SubsidyReportViewComponent } from './views/subsidy-report-view/subsidy-report-view.component';
import { SubsidyReportNonIndComponent } from './components/subsidy-report-non-ind/subsidy-report-non-ind.component';
import { BankSanctionComponent } from './components/bank-sanction/bank-sanction.component';
import { BankSanctionViewComponent } from './views/bank-sanction-view/bank-sanction-view.component';
import { ParkedReportComponent } from './components/parked-report/parked-report.component';
import { ParkedReportViewComponent } from './views/parked-report-view/parked-report-view.component';
import { AdditionalDocumentReportComponent } from './components/additional-document-report/additional-document-report.component';
import { AdditionalDocumentReportViewComponent } from './views/additional-document-report-view/additional-document-report-view.component';
import { BankPendingReportViewComponent } from './views/bank-pending-report-view/bank-pending-report-view.component';
import { BankPendingReportComponent } from './components/bank-pending-report/bank-pending-report.component';
import { SearchCreatedUserComponent } from './components/search-created-user/search-created-user.component';
import { SearchCreatedUserViewComponent } from './views/search-created-user-view/search-created-user-view.component';
import { GrantReleaseComponent } from './components/grant-release/grant-release.component';
import { GrantReleaseViewComponent } from './views/grant-release-view/grant-release-view.component';
import { IntSrcListComponent } from './components/int-src-list/int-src-list.component';
import { IntSrcListViewComponent } from './views/int-src-list-view/int-src-list-view.component';
import { SubsidyDataComponent } from './components/subsidy-data/subsidy-data.component';
import { SubsidyDataViewComponent } from './views/subsidy-data-view/subsidy-data-view.component';
import { PrayasViewComponent } from './views/prayas-view/prayas-view.component';
import { LendingBankReportRequestComponent } from './components/lending-bank-report-request/lending-bank-report-request.component';
import { NrlmDashboardComponent } from './components/nrlm-dashboard/nrlm-dashboard.component';
import { NrlmDashboardViewComponent } from './views/nrlm-dashboard-view/nrlm-dashboard-view.component';
import { registerLocaleData } from '@angular/common';
import localeIn from '@angular/common/locales/en-IN';
// import { HoReportComponent } from './components/ho-report/ho-report.component';
// import { HoReportViewComponent } from './views/ho-report-view/ho-report-view.component';
// import { ViewResponseFileSubsidyComponent } from './views/view-response-file-subsidy/view-response-file-subsidy.component';


registerLocaleData(localeIn, 'en-IN');




// import { GatiShaktiComponent } from './components/gati-shakti/gati-shakti.component';
// import { GatiShaktiViewComponent } from './views/gati-shakti-view/gati-shakti-view.component';













@NgModule({
    declarations: [
        AppComponent,
        HeaderComponent,
        SideBarComponent,
        FooterComponent,
        ConfirmationDialogComponent,
        ConfirmationApprovalDialogComponent,
        ConfirmationWarningDialogComponent,
        // HoReportComponent,
        // HoReportViewComponent,
        // ViewResponseFileSubsidyComponent,
        // UploadBatchFileNpmuFinanceComponent,
        // UploadBatchFileNpmuFinanceViewComponent,
       
        // SubsidyProcessRequestComponent,
        // SubsidyProcessRequestViewComponent,
        // EditSanctionedButNoAbleComponent,
        // EditSanctionedButNoAbleViewComponent,
        // EditSanctionsDetailsDataComponent,
        // EditSanctionsDetailsDataViewComponent,
        // NrlmDashboardComponent,
        // NrlmDashboardViewComponent,
       
        // GetAllVerifiedApplicationsComponent,
        // GetAllVerifiedApplicationsViewComponent,

      
        // IndividualReportNewComponent,
        // IndividualReportNewViewComponent,
        // EditZoneComponent,
        // AreaManagementComponent,
      
       

 
       
        

        // GrantReleaseComponent,
        // GrantReleaseViewComponent,




        // SearchCreatedUserComponent,
        // SearchCreatedUserViewComponent,

        // GatiShaktiComponent,
        // GatiShaktiViewComponent,




        // SubsidyReportNonIndComponent,
        // SubsidyReportComponent,
        // SubsidyReportViewComponent,







        // ZonalVerificationComponent,
        // ZonalVerificationViewComponent,
        // ShiftApplicationComponent,
        // ShiftApplicationViewComponent,


        // ViewDistrictwiseApplicationsComponent,
        // PublicDashboardStateComponent,

    ],
    entryComponents: [ConfirmationDialogComponent, ConfirmationApprovalDialogComponent, ConfirmationWarningDialogComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        RouterModule,
        HttpClientModule,
        Ng4LoadingSpinnerModule.forRoot(),
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        ToastrModule.forRoot({
            preventDuplicates: true,
            closeButton: true
        }),
        ModalModule.forRoot(),
        NgxSpinnerModule,
        ChartsModule,
        NgMultiSelectDropDownModule,
        // RecaptchaModule,
        // NgHcaptchaModule.forRoot({
        //   siteKey: 'b8b28271-59df-41f1-b59c-d2c18054e219',
        //  }),

        // Option #2
        // This option requires you to set the [siteKey] property for every hCaptcha component
        // NgHcaptchaModule.forRoot()
        // ChartsModule
        NgbModule.forRoot(),
        SuperSharedModule,
        DataTableModule,
        NgxPaginationModule,
        // Ng2SearchPipeModule
    ],
    providers: [BaseServiceService, AppCustomPreloader,
        {
            provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor,
            multi: true
        },
        { provide: LOCALE_ID, useValue: 'en-IN' }  // added on 29.1.25 to set default indian format, for currency
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    static injector: Injector;

    constructor(injector: Injector) {
        AppModule.injector = injector;
    }
}
